import { render, staticRenderFns } from "./SalabamLoginPage.vue?vue&type=template&id=803365da&scoped=true"
import script from "./SalabamLoginPage.vue?vue&type=script&lang=js"
export * from "./SalabamLoginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803365da",
  null
  
)

export default component.exports